<div class="ix-slidein-title-bar">
  <h3 class="ix-formtitle">
    {{ title() | translate }}
    @if (requiredRoles()?.length && !(hasRequiredRoles() | async)) {
      <ix-readonly-badge></ix-readonly-badge>
    }
  </h3>

  @if (!disableClose()) {
    <ix-icon
      tabindex="0"
      name="cancel"
      id="ix-close-icon"
      type="button"
      [attr.aria-label]="'Close {formType} Form' | translate: { formType: title }"
      (click)="close()"
      (keydown.enter)="close()"
    ></ix-icon>
  }
</div>

@if (loading()) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
